import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { Device } from '@capacitor/device'
import packageJson from '../../../package.json'
import { PushNotifications } from '@capacitor/push-notifications'
import { AppTrackingTransparency } from 'capacitor-plugin-app-tracking-transparency'

async function getDeviceInfo() {
  const id = await Device.getId()
  const deviceInfo = await Device.getInfo()
  const info = { ...id, ...deviceInfo, userAgent: navigator.userAgent }
  let version = ''
  let build = ''

  if (Capacitor.isNativePlatform()) {
    const appInfo = await App.getInfo()
    version = appInfo.version
    build = appInfo.build
  } else {
    version = packageJson.version
    build = packageJson.build
  }

  let permissionInfo = {}
  if (Capacitor.isNativePlatform()) {
    const pushEnabled = await PushNotifications.checkPermissions()
    permissionInfo = {
      flp_push_status: pushEnabled.receive,
      flp_push_enabled: pushEnabled.receive === 'granted' ? 'true' : 'false',
    }

    if (Capacitor.getPlatform() === 'ios') {
      const status = await AppTrackingTransparency.getStatus()
      permissionInfo = {
        ...permissionInfo,
        flp_att_enabled: status.status,
      }
    }
  }
  return {
    flp_manufacturer: info.manufacturer,
    flp_model: info.model,
    flp_os: info.operatingSystem,
    flp_os_version: info.osVersion,
    flp_application: `${info.platform === 'web' ? 'web' : 'app'}:${info.operatingSystem}`,
    flp_android_sdk_version: info.androidSDKVersion?.toString() ?? 'unknown',
    flp_ios_version: info.iOSVersion?.toString() ?? 'unknown',
    flp_platform: info.platform,
    flp_webview_version: info.webViewVersion,
    flp_user_agent: info.userAgent,
    flp_version: version,
    flp_build: build,
    ...permissionInfo,
  }
}

export default getDeviceInfo
